import { MacroChip } from "authoring/routes/macro/components/macro-chip"

export function MacroTokenWarningBannerEntry({ entry, onSelect }) {
    if (!entry?.token) return null

    return <MacroChip tokenId={entry.token} onClick={handleSelect} />

    function handleSelect() {
        if (typeof onSelect === "function") {
            onSelect(entry)
        }
    }
}
